var componentCls = '.ant-checkbox';
var checkboxStyleFn = function checkboxStyleFn(token) {
  var _ref, _ref2, _ref3;
  return _ref3 = {
    // hover 边框
    '.ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner': {
      borderColor: token.colorBorderHover
    },
    '.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner': {
      backgroundColor: token.colorText
    }
  }, _ref3[".ant-checkbox-disabled.ant-checkbox-checked"] = {
    '.ant-checkbox-inner': {
      backgroundColor: '#CACACC',
      borderColor: '#CACACC'
    },
    '.ant-checkbox-inner:after': {
      borderColor: token.colorWhite
    }
  }, _ref3[componentCls + "-wrapper"] = (_ref2 = {}, _ref2[componentCls + "-indeterminate"] = (_ref = {}, _ref[componentCls + "-inner"] = {
    border: 'transparent !important',
    backgroundColor: token.colorPrimaryHover + " !important",
    '&:after': {
      top: '50%',
      insetInlineStart: '50%',
      width: token.fontSizeLG / 2,
      height: token.fontSizeLG / 8,
      backgroundColor: 'white',
      border: 0,
      transform: 'translate(-50%, -50%) scale(1)',
      opacity: 1,
      content: '""'
    }
  }, _ref), _ref2), _ref3['.ant-checkbox-group'] = {
    columnGap: 16
  }, _ref3;
};

export { checkboxStyleFn };
